import { render, staticRenderFns } from "./Settings.vue?vue&type=template&id=411b6d49"
import script from "./Settings.ts?vue&type=script&lang=ts&external"
export * from "./Settings.ts?vue&type=script&lang=ts&external"
import style0 from "./Settings.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports